import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import parser from 'html-react-parser'

export default function Header({data}) {
    const {headerTitle, headerSubtitle} = data
    return (
        <div className='global-image-content-wrap pb-4 profile-image-content-wrap'>
            <div className='container'>
                <div className='row pt-0'>
                    <div className='col-md-12 text-center'>
                        <figure className='abt-origins-icon'>
                            <StaticImage
                                src='../../../images/origins-icon.png'
                                alt='image'
                            />
                        </figure>
                        <h2 className='heading-level-2 blue-color text-center mb-1'>
                            {headerTitle && parser(headerTitle)}
                        </h2>
                        <p>
                            <strong>{headerSubtitle && parser(headerSubtitle)}</strong>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}
